<template>
  <div class="container">
    <hr class="space space-sm">
    <nav class="nav nav-pills nav-fill">
      <router-link :to="{ name: 'admin-libraries' }" class="nav-link">Libraries</router-link>
      <router-link :to="{ name: 'admin-students' }" class="nav-link">Ученики</router-link>
      <router-link :to="{ name: 'admin-webinars' }" class="nav-link">Вебинары</router-link>
    </nav>
    <hr class="space space-sm">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'admin',
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      countries: state => state.locations.countries,
      cities: state => state.locations.cities,
      regions: state => state.locations.regions
    })
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  methods: {
    openEditModal (item) {
      if (item) {
        this.editGroup = item
        setTimeout(() => {
          this.$refs.modal.showModal()
        }, 100)
      } else {
        this.editGroup = null
        setTimeout(() => {
          this.$refs.modal.showModal()
        }, 100)
      }
    },
    update () {
      this.$refs.modal.hideModal()
    },
    openCountryEditModal (item) {
      if (item) {
        this.editGroup = item
        setTimeout(() => {
          this.$refs.countryModal.showModal()
        }, 100)
      } else {
        this.editGroup = null
        setTimeout(() => {
          this.$refs.countryModal.showModal()
        }, 100)
      }
    },
    updateCountry () {
      this.$refs.countryModal.hideModal()
    },
    openRegionEditModal (item) {
      if (item) {
        this.editGroup = item
        setTimeout(() => {
          this.$refs.regionModal.showModal()
        }, 100)
      } else {
        this.editGroup = null
        setTimeout(() => {
          this.$refs.regionModal.showModal()
        }, 100)
      }
    },
    updateRegion () {
      this.$refs.regionModal.hideModal()
    }
  },
  created () {
    this.$store.dispatch('GET_USER')

    if (this.user && !this.user.isAdmin) {
      this.$router.push({ name: 'profile' })
    }
  }
}
</script>